import { Theme, makeStyles } from "@material-ui/core";
import { IRouterLinkProps } from "./RouterLink";

export const useStyles = makeStyles<Theme>((theme) => ({
  content: (props?: Partial<IRouterLinkProps>) => ({
    fontFamily: theme.typography.fontFamily,
    textDecoration: props?.noUnderline ? "none" : "underline",
    cursor: "pointer",
    color: theme.palette.blue.darkShade1,
  }),
}));
